export default function HandleEnter(event, callback) {
  if (event.key === "Enter") {
    callback()
  }
}
